module.exports = __webpack_public_path__ + "static/media/ee.7e4c6071.svg";